import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import AdminReducer from './slices/AdminSlice'
import AssignmentReducer from './slices/AssignmentSlice'
import AuthReducer from './slices/AuthSlice'
import CompanyReducer from './slices/CompanySlice'
import CustomerReducer from './slices/CustomerSlice'
import EventReducer from './slices/EventSlice'
import GateLogReducer from './slices/GateLogSlice'
import GateReducer from './slices/GateSlice'
import LpnReducer from './slices/LpnSlice'
import OnsiteReducer from './slices/OnsiteSlice'
import PeopleReducer from './slices/PeopleSlice'
import SiteReducer from './slices/SiteSlice'
import SubscriberReducer from './slices/SubscriberSlice'
import UserReducer from './slices/UserSlice'


const persistConfig = {
  key: 'root',
  storage: storage,
}

const rootReducer = combineReducers({
  admin: AdminReducer,
  assignment: AssignmentReducer,
  auth: AuthReducer,
  company: CompanyReducer,
  customer: CustomerReducer,
  event: EventReducer,
  gatelog: GateLogReducer,
  gate: GateReducer,
  lpn: LpnReducer,
  onsite: OnsiteReducer,
  people: PeopleReducer,
  site: SiteReducer,
  subscriber: SubscriberReducer,
  user: UserReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

let store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // action payloads should always be serializable, however, redux-persist can include function payloads
        // as such, let's specify to ignore them
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

let persistor = persistStore(store)

export { store, persistor }
